import {
    GET_APPROVAL_REQUESTS,
    GET_APPROVAL_REQUESTS_SUCCESS,
    GET_APPROVAL_REQUESTS_FAIL,
    CANCEL_APPROVAL_REQUEST,
    CANCEL_APPROVAL_REQUEST_SUCCESS,
    CANCEL_APPROVAL_REQUEST_FAIL,
    DECIDE_APPROVAL_REQUEST,
    DECIDE_APPROVAL_REQUEST_SUCCESS,
    DECIDE_APPROVAL_REQUEST_FAIL,
    OPEN_CANCEL_REQUEST_DIALOG,
    CLOSE_CANCEL_REQUEST_DIALOG,
    OPEN_DECIDE_REQUEST_DIALOG,
    CLOSE_DECIDE_REQUEST_DIALOG,
    SET_LOADING,
} from "./types";

const initialState = {
    // Requests data
    pendingRequests: [],
    approvedRequests: [],
    rejectedRequests: [],
    cancelledRequests: [],

    // Meta data for pagination
    pendingMeta: { page: 1, limit: 20, total: 0, totalPages: 0 },
    approvedMeta: { page: 1, limit: 20, total: 0, totalPages: 0 },
    rejectedMeta: { page: 1, limit: 20, total: 0, totalPages: 0 },
    cancelledMeta: { page: 1, limit: 20, total: 0, totalPages: 0 },

    // Loading states
    loading: false,

    // Dialog states
    cancelDialog: false,
    cancelDialogData: null,
    decideDialog: false,
    decideDialogData: null,

    // Error states
    error: null,
};

const actionsForApprovalReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_LOADING:
            return {
                ...state,
                loading: action.payload,
            };

        case GET_APPROVAL_REQUESTS:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case GET_APPROVAL_REQUESTS_SUCCESS:
            const { requests, meta, status } = action.payload;

            switch (status) {
                case 'PENDING':
                    return {
                        ...state,
                        pendingRequests: requests,
                        pendingMeta: meta,
                        loading: false,
                        error: null,
                    };
                case 'APPROVED':
                    return {
                        ...state,
                        approvedRequests: requests,
                        approvedMeta: meta,
                        loading: false,
                        error: null,
                    };
                case 'REJECTED':
                    return {
                        ...state,
                        rejectedRequests: requests,
                        rejectedMeta: meta,
                        loading: false,
                        error: null,
                    };
                case 'CANCELLED':
                    return {
                        ...state,
                        cancelledRequests: requests,
                        cancelledMeta: meta,
                        loading: false,
                        error: null,
                    };
                default:
                    return {
                        ...state,
                        loading: false,
                        error: null,
                    };
            }

        case GET_APPROVAL_REQUESTS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case CANCEL_APPROVAL_REQUEST_SUCCESS:
        case DECIDE_APPROVAL_REQUEST_SUCCESS:
            // Update the requests lists by removing or updating the item
            const updatedRequest = action.payload;
            return {
                ...state,
                pendingRequests: state.pendingRequests.filter(req => req._id !== updatedRequest._id),
                approvedRequests: updatedRequest.status === 'APPROVED'
                    ? [...state.approvedRequests, updatedRequest]
                    : state.approvedRequests,
                rejectedRequests: updatedRequest.status === 'REJECTED'
                    ? [...state.rejectedRequests, updatedRequest]
                    : state.rejectedRequests,
                cancelledRequests: updatedRequest.status === 'CANCELLED'
                    ? [...state.cancelledRequests, updatedRequest]
                    : state.cancelledRequests,
            };

        case CANCEL_APPROVAL_REQUEST_FAIL:
        case DECIDE_APPROVAL_REQUEST_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case OPEN_CANCEL_REQUEST_DIALOG:
            return {
                ...state,
                cancelDialog: true,
                cancelDialogData: action.payload,
            };

        case CLOSE_CANCEL_REQUEST_DIALOG:
            return {
                ...state,
                cancelDialog: false,
                cancelDialogData: null,
            };

        case OPEN_DECIDE_REQUEST_DIALOG:
            return {
                ...state,
                decideDialog: true,
                decideDialogData: action.payload,
            };

        case CLOSE_DECIDE_REQUEST_DIALOG:
            return {
                ...state,
                decideDialog: false,
                decideDialogData: null,
            };

        default:
            return state;
    }
};

export default actionsForApprovalReducer;
